export default __webpack_public_path__ + "static/media/icon_settingtype_Channel.2bfe9840.png";